var agp = agp || {};


agp.Debug = (function () {
    var enabled = true, 
    history = [];

    function setup(isEnabled) {
        enabled = isEnabled;
    }

    function log () {
        history.push('log', Date.now(), Array.prototype.slice.call(arguments));

        if (window.console && window.console.log && window.console.log.apply){
            window.console.log.apply(window.console, Array.prototype.slice.call(arguments) );
        }
    }

    function warn () {
        history.push('warn', Date.now(), Array.prototype.slice.call(arguments));

        if (window.console && window.console.warn && window.console.warn.apply){
            window.console.warn.apply(window.console, Array.prototype.slice.call(arguments) );
        }
    }

    function trace() {
        if (enabled) {
            log.apply(this, arguments);
        }
    }

    return {
        setup: setup,
        trace: trace,
        history: history,
        log: log,
        warn: warn
    };
}());